import { forwardRef } from 'react';

interface Props extends React.HTMLProps<HTMLInputElement> {
  name: string;
  defaultValue?: string;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
  helperText?: string | React.ReactNode;
  errorText?: string;
  type?: string;
  value?: string;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const Input = forwardRef((props: Props, _ref: React.ForwardedRef<HTMLInputElement>) => {
  const {
    name,
    defaultValue,
    placeholder,
    label,
    disabled,
    onFocus,
    onBlur,
    onChange,
    onKeyDown,
    helperText,
    errorText,
    type = 'text',
    required = true,
    value,
    ...rest
  } = props;

  return (
    <div className="space-y-1">
      {label && (
        <label htmlFor={name} className="block text-sm font-medium text-gray-700 text-wt-text-on-background">
          {label}
        </label>
      )}
      <div className="mt-1">
        <input
          type={type}
          name={name}
          id={name}
          value={value}
          required={required}
          defaultValue={defaultValue}
          placeholder={placeholder}
          disabled={disabled}
          onFocus={(e) => onFocus?.(e)}
          onBlur={(e) => onBlur?.(e)}
          onChange={(e) => onChange?.(e)}
          onKeyDown={(e) => onKeyDown?.(e)}
          className="block w-full rounded-wt border-gray-300 bg-transparent text-sm shadow-sm placeholder:text-sm focus:border-wt-primary focus:ring-wt-primary disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
          {...rest}
        />
        {helperText && <p className="text-xs font-light block leading-snug">{helperText}</p>}
        {errorText && <p className="text-xs font-light block leading-snug text-red-700">{errorText}</p>}
      </div>
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
